/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
// Import as a URL instead of a React component
import linkedInSvgUrl from "./linkedin.svg";

type Props = {
  id?: string;
};

const Primative: React.FC<Props> = (props): JSX.Element => {

  const [buttonText, setButtonText] = useState("Copy Code");

  const handleCopyClick = async (codeId: string) => {
    const codeElement = document.getElementById(codeId);
    const buttonElement = document.getElementById(`copyButton_${codeId}`);

    if (codeElement && buttonElement) {
      const codeText = codeElement.innerText;
      try {
        await navigator.clipboard.writeText(codeText);
        buttonElement.innerText = "Copied!";
        setTimeout(() => {
          buttonElement.innerText = "Copy Code";
        }, 2000);
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
      }
    }
  };
  return (
    <section className="container flex flex-col">
      <div className="flex flex-col my-2 space-y-2">

        <div className="flex flex-col w-full ">
          <h2 className="text-lg py-2 text font-semibold">
            Button Design
          </h2>

          <Tabs defaultValue="example">
            <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
              <TabsTrigger value="example">Example</TabsTrigger>
              <TabsTrigger value="code">Code</TabsTrigger>
            </TabsList>

            <TabsContent value="example" className="p-8 w-10/12">
              <div className="p-3">
                <div className="mt-8 flex flex-wrap gap-4 text-center">
                  <a href="/contact-us/#contact-us-form" className="block w-full uppercase rounded bg-harvey-red px-8 py-3 text-sm font-medium text-white shadow hover:bg-harvey-red/70 focus:outline-none focus:ring active:bg-harvey-red/90 sm:w-auto">
                    Request a consultant
                  </a>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="code" className="p-8 w-10/12">
              <div className="flex items-end w-full justify-end px-6">
                <button
                  id="copyButton_code1"
                  onClick={() => handleCopyClick("code1")}
                  className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                >
                  {buttonText}
                </button>
              </div>
              <div className="flex flex-col items-center px-6 whitespace-pre-line">

                <code id="code1" className="p-8 border rounded border-gray-600 w-full">
                  {`<button className="py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80">
                                  <a href="#" aria-label="" className="text-center uppercase font-medium h-12">BUTTON</a>
                              </button>
                              `}
                </code>

              </div>
            </TabsContent>
          </Tabs>
        </div>

        <div className="flex flex-col w-full">
          <h2 className="text-lg py-2 text center font-semibold">
            Link Design
          </h2>
          <Tabs defaultValue="example">
            <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
              <TabsTrigger value="example">Example</TabsTrigger>
              <TabsTrigger value="code">Code</TabsTrigger>
            </TabsList>

            <TabsContent value="example" className="p-8 w-10/12">
              <div className="p-3">
                <div className="mt-8 flex flex-wrap gap-4 text-center">
                  <a href="tel:0800 222 699" className="block w-full rounded bg-white px-12 py-3 text-sm font-medium text-harvey-red shadow hover:text-harvey-red/70 focus:outline-none focus:ring active:text-harvey-red/90 sm:w-auto">
                    0800 222 699
                  </a>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="code" className="p-8 w-10/12">
              <div className="flex items-end w-full justify-end px-6">
                <button
                  id="copyButton_code2"
                  onClick={() => handleCopyClick("code2")}
                  className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                >
                  {buttonText}
                </button>
              </div>
              <div className="flex flex-col items-center px-6 whitespace-pre-line ">
                <code id="code2" className="p-8 border rounded border-gray-600 w-full">
                  {`<button className="text-white md:mt-0 hover:border rounded-md md:px-4 py-1">
                                  <a href="/contact-us" className="text-center underline decoration-harvey-red underline-offset-4 font-medium
                                  whitespace-nowrap">
                                      This is a Link
                                  </a>
                              </button>
                            `}
                </code>
              </div>
            </TabsContent>
          </Tabs>

        </div>

        <div className="flex flex-col w-full">
          <h2 className="text-lg py-2 text center font-semibold">
            Get In touch - End of page
          </h2>
          <Tabs defaultValue="example">
            <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
              <TabsTrigger value="example">Example</TabsTrigger>
              <TabsTrigger value="code">Code</TabsTrigger>
            </TabsList>

            <TabsContent value="example" className="p-8 w-10/12">
              <div className="p-3">
                <div className='flex flex-col pt-12 space-y-4 w-full px-8 text-white pb-12 z-50'>
                  <div>
                    <h1 className='text-3xl font-extrabold leading-tight text-gradient-red'>
                      Elevate Your Experience with Us
                    </h1>
                    <p className='mt-3 text-lg text-gray-300'>
                      We're here to make your journey exceptional. Get in touch with us!
                    </p>
                  </div>
                  <div className="flex md:flex-row flex-col items-center md:space-x-8 space-y-4 md:space-y-0">
                    <a href="tel:0800 222 699" className="block rounded bg-harvey-red w-full text-center md:w-62 px-12 py-3 text-base font-semibold text-white shadow-md hover:bg-harvey-red/80 focus:outline-none focus:ring active:text-harvey-red/75 transition duration-300 ease-in-out transform hover:scale-105">
                      Call Us
                    </a>
                    <a href="mailto:abc@hnc.com" className="block rounded bg-white w-full text-center md:w-62 px-12 py-3 text-base font-semibold text-harvey-red shadow-md hover:bg-white/70 focus:outline-none focus:ring active:text-harvey-red/75 transition duration-300 ease-in-out transform hover:scale-105">
                      Email Us
                    </a>
                  </div>
                  <div className="flex flex-row space-x-4 items-center pt-8">
                    <p className="text-lg font-semibold">
                      Follow Us
                    </p>
                    <a
                      href="https://www.linkedin.com/showcase/harvey-norman-commercial-and-education-nz/"
                      target="_blank"
                      className="hover:animate-spin"
                      rel="noopener noreferrer"
                      title="LinkedIn"
                    >
                      <img src={linkedInSvgUrl} alt="LinkedIn" className="w-10 h-10" />
                    </a>
                  </div>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="code" className="p-8 w-10/12">
              <div className="flex items-end w-full justify-end px-6">
                <button
                  id="copyButton_code3"
                  onClick={() => handleCopyClick("code3")}
                  className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                >
                  {buttonText}
                </button>
              </div>
              <div className="flex flex-col items-center px-6 whitespace-pre-line ">
                <code id="code3" className="p-8 border rounded border-gray-600 w-full">
                  {`
                   <div class='flex flex-col pt-12 space-y-4 w-full px-8 text-white pb-12 z-50'>
                   <div>
                       <h1 class='text-3xl font-extrabold leading-tight text-gradient-red'>
                           Elevate Your Experience with Us
                       </h1>
                       <p class='mt-3 text-lg text-gray-300'>
                           We're here to make your journey exceptional. Get in touch with us!
                       </p>
                   </div>
                   <div class="flex md:flex-row flex-col items-center md:space-x-8 space-y-4 md:space-y-0">
                       <a href="tel:0800 222 699" class="block rounded bg-harvey-red w-full text-center md:w-62 px-12 py-3 text-base font-semibold text-white shadow-md hover:bg-harvey-red/80 focus:outline-none focus:ring active:text-harvey-red/75 transition duration-300 ease-in-out transform hover:scale-105">
                           Call Us
                       </a>
                       <a href="mailto:abc@hnc.com" class="block rounded bg-white w-full text-center md:w-62 px-12 py-3 text-base font-semibold text-harvey-red shadow-md hover:bg-white/70 focus:outline-none focus:ring active:text-harvey-red/75 transition duration-300 ease-in-out transform hover:scale-105">
                           Email Us
                       </a>
                   </div>
                   <div class="flex flex-row space-x-4 items-center pt-8">
                       <p class="text-lg font-semibold">
                           Follow Us
                       </p>
                       <a
                           href="https://www.linkedin.com/showcase/harvey-norman-commercial-and-education-nz/"
                           target="_blank"
                           class="hover:animate-spin"
                           rel="noopener noreferrer"
                           title="LinkedIn"
                       >
                           <img src={linkedInSvgUrl} alt="LinkedIn" className="w-10 h-10" />
                       </a>
                   </div>
               </div>
                            `}
                </code>
              </div>
            </TabsContent>
          </Tabs>

        </div>

        <div className="flex flex-col w-full">
          <h2 className="text-lg py-2 text center font-semibold">
            Get In touch - End of page Style -2
          </h2>
          <Tabs defaultValue="example">
            <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
              <TabsTrigger value="example">Example</TabsTrigger>
              <TabsTrigger value="code">Code</TabsTrigger>
            </TabsList>

            <TabsContent value="example" className="p-8 w-10/12">
              <div className="p-3">
                <div>
                  <h3 className="text-white mb-12 lg:text-lg font-semibold">
                    Looking for something more specific? &nbsp;
                    <a href="tel:0800 222 699" className="text-red-700 hover:underline underline-offset-2">Call us</a>
                  </h3>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="code" className="p-8 w-10/12">
              <div className="flex items-end w-full justify-end px-6">
                <button
                  id="copyButton_code4"
                  onClick={() => handleCopyClick("code4")}
                  className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                >
                  {buttonText}
                </button>
              </div>
              <div className="flex flex-col items-center px-6 whitespace-pre-line ">
                <code id="code4" className="p-8 border rounded border-gray-600 w-full">
                  {`
                   <div>
                   <h3 class="text-white mb-12 lg:text-lg font-semibold">
                       Looking for something more specific? &nbsp;
                       <a href="tel:0800 222 699" class="text-red-700 hover:underline underline-offset-2">Call us</a>
                   </h3>
               </div>
                            `}
                </code>
              </div>
            </TabsContent>
          </Tabs>

        </div>
      </div>
    </section>
  );
};

export default Primative
